<template>
  <section class="stat-card">
    <header class="stat-card-head">
      <span class="stat-card-accent" aria-hidden="true"></span>
      <h3>{{ title }}</h3>
    </header>
    <div class="stat-card-body"><slot /></div>
  </section>
</template>

<script>
export default {
  name: 'StatCard',
  props: { title: { type: String, default: '' } }
}
</script>

<style scoped>
/* Consumes theme variables from the dashboard root when present,
   falls back to a clean light card when used standalone. */
.stat-card {
  background: var(--card-bg, #fff);
  border: 1px solid var(--card-border, #e5e7eb);
  border-radius: var(--card-radius, 16px);
  padding: var(--card-pad, 14px);
  box-shadow: var(--card-shadow, 0 1px 2px rgba(0, 0, 0, .04));
  -webkit-backdrop-filter: var(--card-blur, none);
  backdrop-filter: var(--card-blur, none);
  position: relative;
  overflow: hidden;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .25s ease;
}

/* top hairline accent */
.stat-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: var(--card-topline, linear-gradient(90deg, transparent, rgba(56, 189, 248, .55), transparent));
  opacity: .9;
  pointer-events: none;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--card-shadow-hover, 0 12px 30px rgba(15, 23, 42, .12));
  border-color: var(--card-border-hover, rgba(56, 189, 248, .45));
}

.stat-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
}

.stat-card-accent {
  width: 4px;
  height: 16px;
  border-radius: 999px;
  background: var(--accent-grad, linear-gradient(180deg, #38bdf8, #818cf8));
  flex: 0 0 auto;
}

.stat-card h3 {
  margin: 0;
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: .2px;
  color: var(--card-title, #0f172a);
}

.stat-card-body {
  color: var(--text, inherit);
}
</style>
